import { createReducer, sortListItemIdsFn } from '../../../utils/state';
import {
    LIST_ARRANGE_BY,
    LIST_SORT_BY,
    LIST_SORT_UNSET,
} from '../../action-types';
import { ListGroupBy } from '@core/models/common/list-group-by';
import { ListSortBy } from '@core/models/common/list-sort-by';
import { ListSortDirection } from '@core/models/common/list-sort-direction';

/**
 * List Sort and Group By reducers.
 * NOTE: the state is still the list state root.
 *
 */
export const listArrangeBy = createReducer({}, {

    [LIST_ARRANGE_BY]: (state, { payload }) => {
        let sortBy: ListSortBy = payload.sortBy || state.sortBy;
        let groupBy: ListGroupBy =  payload.groupBy || state.groupBy;
        let sortDirection: ListSortDirection| ListSortDirection[] = payload.sortDirection || state.sortDirection;

        return { ...state, sortBy, groupBy, sortDirection };
    },

    [LIST_SORT_BY]: (state, { payload }, entities?: any) => {

        let ids: string[] = [...state.ids];

        if (state.sortBy && !state.sortDisabled) {
            ids.sort(sortListItemIdsFn(state.sortBy,
              state.sortDirection,
              entities[payload.domain]));
        }

        return { ...state, ids: [...ids]};

    },

    [LIST_SORT_UNSET]: (state) => {
        return { ...state, sortBy: null};
    },

});
